import type { ReactNode } from 'react';

export type OverlineTone = 'subtle' | 'accent';

const TONE_CLASS: Record<OverlineTone, string> = {
  subtle: 'text-brand-subtle',
  accent: 'text-brand-cyanText',
};

/**
 * Small uppercase label above a group or a heading — group headings in the sidebar, mobile menu and search
 * dropdown, note titles, the hero kicker. One size (11 px semibold) everywhere; spacing goes in `className`
 * (Tailwind orders `mb-*`/`px-*` after `m-0`, so they win).
 * `as` keeps the semantics of each place (a sidebar group is an `h3`, a note title a plain `p`).
 */
export function Overline({
  as = 'p',
  tone = 'subtle',
  className = '',
  children,
}: {
  as?: 'p' | 'h2' | 'h3' | 'div' | 'span';
  tone?: OverlineTone;
  className?: string;
  children: ReactNode;
}) {
  const Element = as;

  return (
    <Element className={`m-0 text-caption font-semibold uppercase tracking-wide ${TONE_CLASS[tone]} ${className}`}>
      {children}
    </Element>
  );
}
